module.exports = __webpack_public_path__ + "fonts/Montserrat-Italic.ec9cfd7.ttf";